<template>
    <ns-modal
        v-model="dialog"
        :fullscreen="fullScreen"
        :title="txc.add_bank_account"
        @input="closeDialog"
    >
        <div class="error-text mb-3">{{ errorMessage }}</div>
        <v-form ref="directDepositFormUS" v-model="addBankAccountFormUS" @submit.prevent>
            <p>{{ txc.direct_deposit_explanation }}</p>
            <div data-test-id="directDepositNameAcct" class="field-label">{{ txc.direct_deposit_name_acct }}</div>
            <v-text-field data-test-id="name" v-model="name" readonly/>
            <div data-test-id="accountType" class="field-label">{{ txc.account_type }}</div>
            <v-radio-group data-test-id="accountType" v-model="accountType" class="mb-2" row>
                <v-radio data-test-id="checking" value="C">
                    <template v-slot:label>{{ txc.checking }}</template>
                </v-radio>
                <v-radio data-test-id="savings" value="S">
                    <template v-slot:label>{{ txc.savings }}</template>
                </v-radio>
            </v-radio-group>
            <div data-test-id="routingNumber" class="field-label">{{ txc.routing_number }}</div>
            <v-text-field data-test-id="routingNumber" v-model="routingNumber" mask="#########" required/>
            <div class="field-hint">
                <a href="#" @click.stop="toggleStub('dd-us-routing')">{{ txc.hint_text }}</a>
            </div>
            <div id="dd-us-routing" class="fancyTooltip hidden">
                <div class="clickable text-right" @click.stop="toggleStub('dd-us-routing')">&times;</div>
                <p>{{ txc.hint_content }}</p>
                <div id="dd-us-routingimg" class="checkImage">&nbsp;</div>
            </div>
            <div data-test-id="accountNumber" class="field-label mt-4">{{ txc.account_number }}</div>
            <v-text-field data-test-id="accountNumber" v-model="accountNumber" :rules="[ruleSet.numberOnly]" required/>
            <div class="field-hint">
                <a href="#" @click.stop="toggleStub('dd-us-acct')">{{ txc.hint_text }}</a>
            </div>
            <div id="dd-us-acct" class="fancyTooltip hidden">
                <div class="clickable text-right" @click.stop="toggleStub('dd-us-acct')">&times;</div>
                <p>{{ txc.hint_content }}</p>
                <div id="dd-us-acctimg" class="checkImage">&nbsp;</div>
            </div>
            <v-checkbox :rules="[ruleSet.required]" class="mt-4" required>
                <template v-slot:label>
                    <span data-test-id="agreeToTerms" class="terms-text" v-html="ddAgreementTerms.terms_text"></span>
                </template>
            </v-checkbox>
        </v-form>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        :disabled="!addBankAccountFormUS || !accountNumber || !routingNumber"
                        block
                        class="primary-hit mb-2 fluid"
                        flat
                        @click="submitBankInfoUS"
                        data-test-id="save"
                    >{{ txcg.save }}
                    </button>
                </v-flex>
                <v-spacer/>
                <v-flex xs12>
                    <button
                        block
                        class="secondary-hit fluid"
                        flat
                        outline
                        @click="closeDialog"
                        data-test-id="cancel"
                    >{{ txcg.cancel }}
                    </button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import * as ruleSet from '../../repositories/globalRules.js'
import profileUtils from '../../repositories/profileUtils.js'

import {ProfileService} from '@nuskin/ns-account'
import {mapGetters, mapActions} from 'vuex'

import {NsModal} from '@nuskin/design-components'

export default {
    components: {
        NsModal
    },
    data() {
        return {
            ruleSet,
            dialog: true,
            errorMessage: '',
            addBankAccountFormUS: {},
            name: '',
            accountType: 'C',
            routingNumber: '',
            accountNumber: '',
            rules: {
                numberOnly: ruleSet.numberOnly,
                required: ruleSet.required
            }
        }
    },
    computed: {
        ...mapGetters({
            txc: 'translationsDirectDeposit',
            txcg: 'translationsGlobal',
            txce: 'translationsError',
            fullScreen: 'mobileView',
            localName: 'localName',
            account: 'account',
            ddAgreementTerms: 'directDepositAgreementTerms'
        })
    },
    methods: {
        ...mapActions(['setAccount']),
        toggleStub(id) {
            let divID = document.getElementById(id)
            divID.classList.toggle('hidden')
            profileUtils.publishAnalytics(
                this.$analytics.category.deposits,
                'US_bank_account',
                `${id}_help_link`
            )
        },
        closeDialog() {
            this.$emit('closeDialog') 
            this.errorMessage = ''
        },
        submitBankInfoUS() {
            let bankData = {
                accountName: this.name,
                accountNumber: this.accountNumber,
                routingNumber: this.routingNumber,
                accountType: this.accountType
            }
            ProfileService.updateBankInfo(bankData)
                .then(response => {
                    if (response) {
                        this.$emit('bankAccountAdded')
                        profileUtils.publishAnalytics(
                            this.$analytics.category.deposits,
                            'US_bank_account',
                            'added',
                            { email: this.account.email }
                        )
                    }
                })
                .catch(error => {
                    this.errorMessage = this.txce.nonSpecific;
                    // this.errorMessage += error.response.data.error.errors[0].message;
                })
        }
    },
    created() {
        this.name = this.localName
        profileUtils.publishAnalytics(
            this.$analytics.category.deposits,
            'US_bank_account_dialog',
            'opened'
        )
    },
    destroyed() {
        profileUtils.publishAnalytics(
            this.$analytics.category.deposits,
            'US_bank_account_dialog',
            'closed'
        )
    }
}
</script>
<style scoped lang="scss">
    @use "sass:map";
    @use "~@nuskin/ns-core-styles/src/scss/global.mixins";
    .terms-text {
       @include global.paragraph-m();
    }
</style>
